import { useEffect, useMemo } from "react"

import { useNavigate } from "react-router-dom"

import {
    type FeatureFlag,
    FeatureFlagsExistenceLogicalOperator,
} from "@common-shared/config/featureFlags.config"

import { FeatureFlagsHelper } from "../helpers/featureFlags.helper"
import { UtilHelper } from "../helpers/util.helper"
import { useAppSelector } from "../store/selectors/app.selector"
import { runtimeSelector } from "../store/selectors/runtime.selector"

export const useIsFeatureFlagEnabled = (
    neededFeatureFlag: FeatureFlag | FeatureFlag[],
    existenceLogicalOperator = FeatureFlagsExistenceLogicalOperator.OR,
    redirectRouteOnMissing?: string,
): boolean | null => {
    const navigate = useNavigate()
    const runtime = useAppSelector(runtimeSelector)

    const isEnabled = useMemo<boolean | null>(() => {
        return runtime.enabledFeatureFlags
            ? FeatureFlagsHelper.isFeatureFlagEnabled(
                  runtime.enabledFeatureFlags,
                  neededFeatureFlag,
                  existenceLogicalOperator,
              )
            : null
    }, [runtime.enabledFeatureFlags])

    useEffect(() => {
        if (isEnabled !== false || !redirectRouteOnMissing) {
            return
        }

        UtilHelper.redirectTo(redirectRouteOnMissing, navigate)
    }, [isEnabled, redirectRouteOnMissing])

    return isEnabled
}
